import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6726e953"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metadata-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { class: "navigation-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_6 = { class: "navigation-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 資料を送信 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplateDownload = _resolveComponent("TemplateDownload")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TemplateDownload),
      _hoisted_2,
      _createVNode(_component_FileUpload, {
        modelValue: _ctx.file,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.file) = $event)),
        errMsgFlg: _ctx.errMsgFlg
      }, null, 8, ["modelValue", "errMsgFlg"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('outputSelect'))),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('outputSelect')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.send,
          onKeydown: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          disabled: !_ctx.file || _ctx.errMsgFlg,
          buttonId: 'button-send'
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_DssIcon, {
              icon: "arrow-right",
              style: {"font-size":"18px"}
            })
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown", "disabled"])
      ])
    ])
  ], 64))
}